import { useHasAccess } from 'lib-shared-access-control';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { SettingsIntegrationsView } from './settingsIntegrations.view';
import { settingsIntegrationsApiTokensRoutes } from './views/apiTokens';
import {
  settingsIntegrationsCardsRoutes,
  SettingsIntegrationsCardsView,
} from './views/cards';
import { settingsIntegrationsChatbotsRoutes } from './views/chatbots';
import { settingsIntegrationsPartnerWidgetRoutes } from './views/partnerWidget';
import { settingsIntegrationsWebformRoutes } from './views/webform';
import { settingsIntegrationsWebhooksRoutes } from './views/webhooks';

const SettingsIntegrationsRoutes = (): JSX.Element => {
  const { partnerIntegrationsWidget } = useFeatureFlag([
    'partner-integrations-widget',
  ]);
  const hasChannelSetupAccess = useHasAccess(
    'settings.integration.channel.setup',
  );
  const hasChannelEditAccess = useHasAccess(
    'settings.integration.channel.edit',
  );

  return (
    <Routes>
      <Route path="*" element={<SettingsIntegrationsView />}>
        <Route index element={<SettingsIntegrationsCardsView />} />

        {partnerIntegrationsWidget
          ? settingsIntegrationsPartnerWidgetRoutes
          : null}
        {settingsIntegrationsWebformRoutes}
        {settingsIntegrationsApiTokensRoutes}
        {settingsIntegrationsWebhooksRoutes}
        {settingsIntegrationsCardsRoutes}
        {hasChannelSetupAccess &&
          hasChannelEditAccess &&
          settingsIntegrationsChatbotsRoutes}
        <Route path="*" element={<Navigate to="/settings/integrations" />} />
      </Route>
    </Routes>
  );
};

export const settingsIntegrationsRoutes = (
  <Route path="integrations/*" element={<SettingsIntegrationsRoutes />} />
);
